import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { swipeToggleStatus } from '../../App/common/reduxs/swipe/reduxApi';
import { SWIPE_STYLE } from '../../App/common/styles/swipe_style';
import { getRoleAuth } from '../../App/login/redux/authApi';
import { getProfil } from '../profile/redux/reduxApi';
import {
  getAnnouncements,
  downloadFile,
} from '../_features/announcement/redux/reduxApi';
import {
  getTingkats,
  setReadActivity,
} from '../_features/pembelajaran/redux/reduxApi';
import { getPembelajaran } from './redux/reduxApi';
import { getSlideshows } from '../_features/slideshow/redux/reduxApi';
import AnnouncementWidget from './AnnouncementWidget';
import SlideShowWidget from './SlideShowWidget';
import PembelajaranWidget from './PembelajaranWidget';
import { openModal } from '../../App/modals/redux/modalActions';
import { getUnreadPesan } from './redux/reduxApi';
import toast from 'react-hot-toast';
import { mdiEmailPlusOutline } from '@mdi/js';
import Icon from '@mdi/react';
import {
  getLocalStorage,
  setLocalStorage,
} from '../../App/common/helpers/useLocaleStorage';

function mapState(state) {
  let auth = state.auth;
  let scope = auth?.isAuth ? auth.authorities : {};
  let loading = state.async.loading;
  let deviceId = auth?.deviceId;
  if (deviceId) auth.name = auth.username;
  let pembelajaran = state.pembelajaran;
  const materis = pembelajaran?.materis;
  const tugass = pembelajaran?.tugass;
  const latihans = pembelajaran?.latihans;
  const tess = pembelajaran?.tess;
  let tingkats = pembelajaran?.tingkats;
  let kelass = pembelajaran?.kelass;
  let total = pembelajaran?.total;
  let role = state.userrole;
  let slideshows = state.slideshows;
  let announcements = state.announcements;
  let swipe = state.swipe;
  return {
    auth,
    scope,
    loading,
    deviceId,
    role,
    slideshows,
    announcements,
    materis,
    tugass,
    latihans,
    tess,
    tingkats,
    kelass,
    total,
    swipe,
  };
}

const actions = {
  openModal,
  swipeToggleStatus,
  getRoleAuth,
  getProfil,
  getAnnouncements,
  getTingkats,
  setReadActivity,
  getPembelajaran,
  getSlideshows,
  getUnreadPesan,
  downloadFile,
};

function Index({
  auth,
  loading,
  openModal,
  swipeToggleStatus,
  getRoleAuth,
  getProfil,
  getAnnouncements,
  downloadFile,
  deviceId,
  getTingkats,
  setReadActivity,
  getPembelajaran,
  announcements,
  materis,
  tugass,
  latihans,
  tess,
  tingkats,
  kelass,
  total,
  getSlideshows,
  getUnreadPesan,
  slideshows,
}) {
  let history = useHistory();

  const handleCloseEmailToast = useCallback((tId) => {
    toast.dismiss(tId);
  }, []);

  // detect if user leave page close emailToast;
  useEffect(() => {
    const handleBeforeUnload = () => {
      toast.remove();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      toast.remove();
    };
  }, []);

  const emailRecoveryToast = useCallback(
    () =>
      toast.loading(
        (t) => (
          <div
            className='flex justify-between'
            style={{ position: 'relative' }}
          >
            <div className='hand-pointer2'>
              <p
                onClick={() => {
                  history.push('/pengaturan/email-recovery');
                  toast.dismiss(t.id);
                }}
              >
                <span className='has-text-info has-text-weight-semibold'>
                  Klik
                </span>{' '}
                untuk registrasi email agar dapat melakukan password recovery.
              </p>
              <p
                className='has-text-weight-semibold mt-2 has-text-info'
                style={{ fontSize: 14 }}
              >
                Di Pengaturan &gt; Email Recovery
              </p>
            </div>
            <button
              className='delete'
              onClick={() => handleCloseEmailToast(t.id)}
              style={{ position: 'absolute', right: -10, top: 24 }}
            ></button>
          </div>
        ),
        {
          icon: (
            <span className='has-text-info'>
              <Icon path={mdiEmailPlusOutline} size={1} />
            </span>
          ),
        },
      ),
    [handleCloseEmailToast, history],
  );

  useEffect(() => {
    if (deviceId) {
      window.ReactNativeWebView.postMessage('dash-loaded');
    }
  }, [deviceId]);

  // Run Email Recovery popup with delay of 2sec
  useEffect(() => {
    let showEmailToast = getLocalStorage('displayEmailToast', null);
    let showToast = false;
    if (!showEmailToast?.alreadyDisplay) showToast = true;
    if (showEmailToast?.dontDisplay === 'always') showToast = false;
    if (showToast) {
      setTimeout(() => {
        emailRecoveryToast();
        if (!showEmailToast)
          setLocalStorage('displayEmailToast', { alreadyDisplay: true });
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getRoleAuth(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getRoleAuth]);

  useEffect(() => {
    getTingkats(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLink = useCallback(
    (url, id, title, content) => {
      history.push(url);
      if (id) {
        setReadActivity(auth, history, id, title, content);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setReadActivity],
  );

  return (
    <>
      <SwipeHandler swipeToggleStatus={swipeToggleStatus} />
      <BodyCard auth={auth}>
        <SlideShowWidget
          auth={auth}
          history={history}
          loading={loading}
          slideshows={slideshows}
          getSlideshows={getSlideshows}
          handleLink={handleLink}
        />
        <AnnouncementWidget
          auth={auth}
          history={history}
          openModal={openModal}
          announcements={announcements}
          getAnnouncements={getAnnouncements}
          handleLink={handleLink}
          downloadFile={downloadFile}
        />
        <PembelajaranWidget
          auth={auth}
          history={history}
          loading={loading}
          materis={materis}
          tugass={tugass}
          latihans={latihans}
          tess={tess}
          tingkats={tingkats}
          kelass={kelass}
          total={total}
          getPembelajaran={getPembelajaran}
          handleLink={handleLink}
        />
        <AuthContent
          auth={auth}
          history={history}
          getProfil={getProfil}
          getUnreadPesan={getUnreadPesan}
        />
        <div style={auth?.deviceId ? { marginBottom: 54 } : {}}></div>
      </BodyCard>
    </>
  );
}

function BodyCard({ children, auth }) {
  if (auth.isAuth !== true) return <Redirect to='/login' />;
  if (auth.isAuth === true && auth.registerParents)
    return <Redirect to='/register-2' />;

  return (
    <div className='column is-10-desktop is-offset-2-desktop is-9-tablet is-offset-3-tablet is-12-mobile'>
      <div className='p-1'>
        <div className='columns is-2 is-multiline is-variable is-desktop'>
          {children}
        </div>
      </div>
    </div>
  );
}
function SwipeHandler({ swipeToggleStatus }) {
  const handlers = useSwipeable({
    trackMouse: true,
    onSwipedRight: () => {
      swipeToggleStatus(true);
    },
  });
  return <div {...handlers} style={SWIPE_STYLE} />;
}

function AuthContent({ auth, history, getProfil, getUnreadPesan }) {
  useEffect(() => {
    getProfil(auth, history);
    getUnreadPesan(auth, history);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export default connect(mapState, actions)(Index);
